/* RESPONSIBLE TEAM: team-ai-insights */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { taskFor } from 'ember-concurrency-ts';
import type IntlService from 'embercom/services/intl';
import type RouterService from '@ember/routing/router-service';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import type Transition from '@ember/routing/transition';
import type ContentSuggestionsService from 'embercom/services/content-suggestions-service';
import type KnowledgeHubDrawerEditorService from 'embercom/services/knowledge-hub-drawer-editor-service';
import type OptimizeFinReasonsController from 'embercom/controllers/apps/app/automation/fin-ai-agent/analyze/optimize-fin-reasons';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';
import type ReportingUnderlyingDataService from 'embercom/services/reporting-underlying-data-service';

export default class OptimizeFinReasonsRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare router: RouterService;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare permissionsService: $TSFixMe;
  @service declare contentSuggestionsService: ContentSuggestionsService;
  @service declare knowledgeHubDrawerEditorService: KnowledgeHubDrawerEditorService;
  @service declare aiAgentSetupService: AiAgentSetupService;
  @service declare reportingUnderlyingDataService: ReportingUnderlyingDataService;

  analytics = {
    section: 'automation',
    place: 'optimize-fin-reasons',
  };

  routeWhenNotOptedIn = 'apps.app.automation.fin-ai-agent.analyze.ai-insights';

  get titleToken() {
    return this.intl.t('ai-agent.analyze.optimize-fin');
  }

  resetController(controller: OptimizeFinReasonsController, isExiting: boolean) {
    if (isExiting) {
      this.knowledgeHubDrawerEditorService.removeEmberStickyQueryParams(controller);
    }
  }

  async beforeModel(transition: Transition) {
    if (!this.appService.app.canSeeAiInsightsBeta) {
      this.router.transitionTo(this.routeWhenNotOptedIn);
      return;
    }
    this.permissionsService.ensurePermissionWhenTransitioning('can_access_reporting', transition);
    await taskFor(this.reportingMetrics.setup).perform();
    await this.contentSuggestionsService.fetchTopicsSummary();
    await taskFor(this.reportingUnderlyingDataService.loadAttributeMappings).perform(
      'conversation_custom_fields#customer_experience_attributes',
      'conversation',
      true,
    );
    this.aiAgentSetupService.loadFinWorkflowsCount();
    this.aiAgentSetupService.loadSetupRulesets();
  }
}
